import {Component, OnInit} from '@angular/core';
import {AuthService, BlockAbstractComponent, ParserService} from '@gallaghercp/core-frontend';
import {Subscription, interval} from 'rxjs';

@Component({
    standalone: false,
    selector: 'core-block-countdown',
    templateUrl: './block-countdown.component.html',
})

export class BlockCountdownComponent extends BlockAbstractComponent implements OnInit {

    private subscription!: Subscription;
    private milliSecondsInASecond: number = 1000;
    private hoursInADay: number = 24;
    private minutesInAnHour: number = 60;
    private secondsInAMinute: number = 60;
    private timeDifference?: number;

    public days?: string;
    public hours?: string;
    public minutes?: string;
    public seconds?: string;

    constructor(
        protected override parser: ParserService,
        protected override auth: AuthService
    ) {
        super(
            parser,
            auth
        );
    }

    private static leadingZero(num: number, size: number = 2): string {
        let target = num + '';

        while (target.length < size) {
            target = '0' + target;
        }

        return target;
    }

    private getTimeDifference() {
        this.timeDifference = new Date(this.block.data.countTo).getTime() - new Date().getTime();

        this.allocateTimeUnits(this.timeDifference);
    }

    private allocateTimeUnits(timeDifference: number) {
        this.days = BlockCountdownComponent.leadingZero(Math.floor((timeDifference) / (this.milliSecondsInASecond * this.minutesInAnHour * this.secondsInAMinute * this.hoursInADay)));
        this.hours = BlockCountdownComponent.leadingZero(Math.floor((timeDifference) / (this.milliSecondsInASecond * this.minutesInAnHour * this.secondsInAMinute) % this.hoursInADay));
        this.minutes = BlockCountdownComponent.leadingZero(Math.floor((timeDifference) / (this.milliSecondsInASecond * this.minutesInAnHour) % this.secondsInAMinute));
        this.seconds = BlockCountdownComponent.leadingZero(Math.floor((timeDifference) / (this.milliSecondsInASecond) % this.secondsInAMinute));
    }

    override ngOnInit() {
        super.ngOnInit();
        this.setTimer();
    }

    setTimer() {
        this.subscription = interval(1000).subscribe(() => {
            this.getTimeDifference();
        });
    }

    override ngOnDestroy() {
        super.ngOnDestroy();
        this.subscription.unsubscribe();
    }

}
